import { useEffect, useState } from "react";
import { Card, CardBody, Spinner } from "reactstrap";
import { getAllLogsApi } from "../../../api/apiUrlConst";
import ActivityLogTable from "../../Common/ActivityLogTable";

const SystemActivityPage = () => {

  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const loadLogs = async () => {
    try {
      setLoading(true);

      const res = await getAllLogsApi(1);

      setLogs(res.data);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs();
  }, []);

  return (
    <Card>
      <CardBody>

        <h4>System Activity Logs</h4>

        {loading ? (
          <Spinner />
        ) : (
          <ActivityLogTable logs={logs} />
        )}

      </CardBody>
    </Card>
  );
};

export default SystemActivityPage;